import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { getPersonalizationAccess } from 'personalization-lib/utils/auth';
import { useGetPersonalizationStrategyQuery } from 'personalization-lib/__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeRpc.hooks';
const usePersonalizationStrategy = (strategyId, options) => {
  const personalizationAccess = getPersonalizationAccess();
  const _useGetPersonalizatio = useGetPersonalizationStrategyQuery(Object.assign({
      variables: {
        id: strategyId
      },
      skip: !strategyId || !personalizationAccess.view
    }, options)),
    {
      data
    } = _useGetPersonalizatio,
    rest = _objectWithoutPropertiesLoose(_useGetPersonalizatio, _excluded);
  return Object.assign({
    strategy: data === null || data === void 0 ? void 0 : data.personalizationStrategy
  }, rest);
};
export default usePersonalizationStrategy;